import type { Landmark } from '../../../data/types';
import type { Ring, Vec2 } from '../../../geo/types';
import { vesselOutline } from './churchVessel';
import reading from './sintPieterskapelPlan.json';
import { toLayout, type PlanFrame } from './planFrame';

export function sintPieterskapelPlan(landmark: Landmark) {
  if (landmark.id !== 'landmark-sint-pieterskapel')
    throw new Error(`No Pieters chapel plan for ${landmark.id}`);
  const x = landmark.params['anchorX'],
    y = landmark.params['anchorY'];
  if (typeof x !== 'number' || typeof y !== 'number')
    throw new Error(`${landmark.id} lacks its component anchor`);
  const frame: PlanFrame = { origin: [x, y], heading: landmark.heading, ring: [] };
  return { frame, ...reading, vessel: { ...reading.vessel, apse: 'flat' as const } };
}

/** Grounded nave and shallow side piers; no full-plot platform or canal extension. */
export function sintPieterskapelFoundations(landmark: Landmark): Ring[] {
  const { frame, vessel: v, buttresses: b } = sintPieterskapelPlan(landmark);
  const piers = b.centres.flatMap((u) =>
    [-1, 1].map((side) => {
      const inner = side * (v.half - 0.1),
        outer = side * (v.half + b.depth);
      return [
        [u - b.width / 2, inner],
        [u + b.width / 2, inner],
        [u + b.width / 2, outer],
        [u - b.width / 2, outer],
      ] as Vec2[];
    })
  );
  return [vesselOutline(v), ...piers].map((r) => r.map((p) => toLayout(frame, p)));
}
